const inicialState = {
  modalJustificativa: false,
  modalBloco: false,
  modalConfirmar: false,
  listarBlocos: [],
  carregarLaminas: false,
  carregarBlocos: false,
  blocoText: 'Adicionar Bloco',
  blocoId: null,
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/app/common/requisicaoCongelacao/tabs/bloco/bloco.state.js